import React from 'react'
import { Helmet } from 'react-helmet'
import styles from './LandingPage.module.scss'
import { ROUTES } from '../../lib/constants'
import { PlanCard } from '../../components/PlanCard/PlanCard'
import { Pill } from '../../components/Pill/Pill'
import SoccerClubLogo from '../../images/oc-soccer-club-logo.svg'
import SoccerClubImageD from '../../images/soccer-club-d.jpg'
import SoccerClubImageM from '../../images/soccer-club-m.jpg'
import { ReviewsSlider } from '../../components/ReviewsSlider/ReviewSlider'
import { LogosCarousel } from '../../components/LogosCarousel/LogosCarousel'
import { Image } from '../../components/Image/Image'

export const LandingPage = (): React.JSX.Element => {
  return (
    <>
      <Helmet>
        <title>{ROUTES.landing.title}</title>
      </Helmet>

      <section className={styles.hero}>
        <div className={styles.designElement}></div>

        <div className={`grid-12 ${styles.container}`}>
          <h1 className="headline__h1-xl color--daylight-blue">
            Upgrade Your
            <br />
            Internet Experience
          </h1>
          <p className="color--marina-blue">
            Choose the package below that&rsquo;s built for your needs:
          </p>
        </div>
      </section>

      <section className={styles.plans}>
        <div className={styles.wave}></div>
        <div className={`grid-12 ${styles.container}`}>
          <div className={styles.innerGrid}>
            <PlanCard
              className={styles.one}
              landing={true}
              type="1 Gig"
              gigInternetLinkText="Learn More"
            >
              <h4>Built For:</h4>

              <ul className="checkmark-list">
                <li>Connectivity and reliability for your everyday use!</li>
                <li>Control of your WiFi experience across all your devices</li>
                <li>
                  Streaming TV, social media, homework, and optimizing your<br /> daily
                  grind
                </li>
              </ul>
            </PlanCard>

            <div className={styles.two}>
              <Pill>Best Value!</Pill>

              <PlanCard landing={true} type="2 Gigs" gigInternetLinkText="Learn More">
                <h4>Built For:</h4>

                <ul className="checkmark-list">
                  <li>
                    Dependable Work from Home Connections - worry-free video
                    calls!
                  </li>
                  <li>
                    Gaming, Entertaining, Security, and Smart Home functionality
                  </li>
                  <li>
                    Enhancing your home&rsquo;s coverage - mesh WiFi extender
                    included
                  </li>
                </ul>
              </PlanCard>
            </div>

            <PlanCard
              className={styles.five}
              landing={true}
              type="5 Gigs"
              gigInternetLinkText="Learn More"
            >
              <h4>Built For:</h4>

              <ul className="checkmark-list">
                <li>
                  Kicking back and enjoying OC's finest internet experience{' '}
                </li>
                <li>
                  A First-Class lifestyle: more devices, premium speed, max
                  capacity, and dedicated Concierge service
                </li>
                <li>
                  Upgraded coverage across your home - indoor and outdoor
                  extenders included
                </li>
              </ul>
            </PlanCard>
          </div>
        </div>
      </section>

      <section className={styles.gigLife}>
        <div className={styles.designElement}></div>

        <div className={`grid-12 ${styles.container}`}>
          <h2 className="headline__h1 color--white">
            The Cityside Fiber
            <br />
            GIG LIFE™ Includes:
          </h2>

          <ul className="checkmark-list">
            <li>Concierge-level service from our local OC team</li>
            <li>True Gig-speed Internet on upload and download </li>
            <li>No long-term contracts or end-of-contract pricing gimmicks</li>
            <li>
              Standard professional installation and WiFi router / modem
              included
            </li>
            <li>
              Seamless WiFi Smart Phone calling at home – inside, outside, and
              poolside
            </li>
            <li>
              Support your OC neighbors through Cityside&rsquo;s community
              sponsorships
            </li>
          </ul>
        </div>
      </section>

      <section className={styles.invest}>
        <div className={`grid-12 ${styles.container}`}>
          <h2 className="headline__h1 color--orange-gradient">
            Invested in Orange County
          </h2>

          <div className={styles.soccerClub}>
            <Image
              sources={[
                { src: SoccerClubImageM, breakpoint: 'default' },
                { src: SoccerClubImageD, breakpoint: '960px' },
              ]}
              alt="Orange County Socccer Club Mascot"
              loading="lazy"
            />

            <p className="subtitle">Official Internet Provider of the</p>

            <div className={styles.content}>
              <Image
                src={SoccerClubLogo}
                alt="Orange County Socccer Club Logo"
                loading="lazy"
              />
              <p className="headline__h3">
                Orange County
                <br />
                Soccer Club
              </p>
            </div>
          </div>

          <div className={styles.reviews}>
            <ReviewsSlider />
          </div>
        </div>
      </section>

      <section className={styles.sponsors}>
        <h2 className="headline__h2 color--marina-blue">
          And Proud Sponsors of
        </h2>

        <div className={styles.container}>
          <LogosCarousel />
        </div>
      </section>
    </>
  )
}
